export const isSafari = (userAgent = window.navigator.userAgent) => {
  // Check if Safari and WebKit are present, but exclude Chrome, Edge, and other webkit-based browsers
  return /Safari/i.test(userAgent) && /WebKit/i.test(userAgent) && !userAgent.includes('Chrome') && !userAgent.includes('Chromium') && !userAgent.includes('Edge') && !userAgent.includes('OPR') &&
  // Opera
  !userAgent.includes('SamsungBrowser');
};
export const isDesktopSafari = (userAgent = window.navigator.userAgent) => {
  return isSafari(userAgent) && !userAgent.includes('Mobile') && !userAgent.includes('iPhone') && !userAgent.includes('iPad') && !userAgent.includes('iPod');
};